<template v-if="isLoggedIn">
  <div class="account-page">
    <div class="account-shell">
      <!-- Sidebar -->
      <aside class="account-sidebar">
        <ul class="nav secondary">
          <li class="d-flex align-items-center w-100">
            <a href="#"   
              :class="{ active: currentSection === 'account' }"
              @click.prevent="navigateTo('account')"
            >
            Account
            </a>
              <i class="bi bi-box-arrow-right logouticon text-danger ms-auto" @click.prevent="logout"></i>
          </li>
          <li>
            <a href="#" :class="{ active: currentSection === 'orders' }" @click.prevent="navigateTo('orders')">
              Orders
            </a>
          </li>
          <li>
            <a href="#" :class="{ active: currentSection === 'payments' }" @click.prevent="navigateTo('payments')">
              Payments
            </a>
          </li>
          <li>
            <a href="#" :class="{ active: currentSection === 'tickets' }" @click.prevent="navigateTo('tickets')">
              Tickets
            </a>
          </li>
          <li>
            <a href="#" :class="{ active: currentSection === 'referrals' }" @click.prevent="navigateTo('referrals')">
              Referrals
            </a>
          </li>
          <li>
            <a href="#" :class="{ active: currentSection === 'messages' }" @click.prevent="navigateTo('messages')">
              Messages
            </a>
          </li>
          <li>
            <a href="#" :class="{ active: currentSection === 'notifications' }" @click.prevent="navigateTo('notifications')">
              Notifications
            </a>
          </li>
          
        </ul>
      </aside>

      <!-- Main content -->
      <main class="account-content">
        <!-- Account Section -->
        <div v-if="currentSection === 'account'" class="grid">
          <!-- Account Details -->
          <section class="card">
            <header class="card-h">
              <span>PERSONAL DETAILS</span>
              <button class="icon-btn" aria-label="Edit profile" @click="openEdit('profile')">
                <i class="fa-solid fa-pen"></i>
              </button>
            </header>
            <div class="card-b">
              <p class="muted">Name: {{ userDetails?.firstname }}</p>
              <p class="muted">Email: {{ userDetails?.email }}</p>
              <p class="muted">Contact: {{ userDetails?.phone_number }}</p>
            </div>
          </section>

          <!-- Address Book -->
          <section class="card">
            <header class="card-h">
              <span>ADDRESS BOOK</span>
              <button class="icon-btn" aria-label="Edit address" @click="openEdit('address')">
                <i class="fa-solid fa-pen"></i>
              </button>
            </header>
            <div class="card-b">
              <p>Your address:</p>
              <p class="muted">
                {{ userDetails?.address }}<br />
                {{ userDetails?.street }}<br />
                {{ userDetails?.city }}, {{ userDetails?.country }}
              </p>
            </div>
          </section>
        </div>

        <!-- Orders Section -->
        <div v-else-if="currentSection === 'orders'" class="grid">
          <section class="card full">
            <header class="card-h">MY ORDERS</header>
            <div class="card-b">
              <p v-if="orders.length === 0">No orders found.</p>

              <div v-else>
                <table class="ticket-table desktop-only">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Description</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th>Created</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(order, index) in orders" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ order.product_name }}</td>
                      <td>{{ order.total_amount }}</td>
                      <td>
                        <span :class="{
                          'badge bg-warning text-dark p-1': order.order_status === 'open',
                          'badge bg-secondary p-1': order.order_status === 'pending',
                          'badge bg-success p-1': order.order_status === 'closed'
                        }">
                          {{ order.order_status }}
                        </span>
                      </td>

                      <td>{{ new Date(order.order_date).toLocaleDateString('en-GB') }}</td>
                    </tr>
                  </tbody>
                </table>

                <!-- Cards for small screens -->
                <ul class="ticket-list mobile-only">
                  <li v-for="(order, index) in orders" :key="index" class="ticket-item">
                    <div class="ticket-header">
                      <span class="ticket-title">{{ order.product_name }}</span>
                      <span :class="{
                        'badge bg-warning text-dark p-1': order.order_status === 'open',
                        'badge bg-secondary p-1': order.order_status === 'pending',
                        'badge bg-success p-1': order.order_status === 'closed'
                      }" class="ticket-status">
                        {{ order.order_status }}
                      </span>
                    </div>

                    <p class="ticket-response">
                      <strong>Amount:</strong>
                      <span>{{ order.total_amount }}</span>
                    </p>

                    <p class="ticket-date">
                      <strong>Created:</strong>
                      {{ new Date(order.order_date).toLocaleDateString('en-GB') }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>

        <!-- Payments Section -->
        <div v-else-if="currentSection === 'payments'" class="grid">
          <section class="card full">
            <header class="card-h">PAYMENT HISTORY</header>
            <div class="card-b">
              <p v-if="payments.length === 0">No saved payment methods.</p>

              <div v-else>
                <table class="ticket-table desktop-only">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Trans Ref</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th>Created</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(payment, index) in payments" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ payment.transaction_reference }}</td>
                      <td>{{ payment.amount_paid }}</td>
                      <td>
                        <span :class="{
                          'badge bg-warning text-dark p-1': payment.posted == '0',
                          'badge bg-success p-1': payment.posted == '1'
                        }">
                          {{ payment.posted == '1' ? 'Closed' : 'Open' }}
                        </span>
                      </td>

                      <td>{{ new Date(payment.paid_at).toLocaleDateString('en-GB') }}</td>
                    </tr>
                  </tbody>
                </table>

                <!-- Cards for small screens -->
                <ul class="ticket-list mobile-only">
                  <li v-for="(payment, index) in payments" :key="index" class="ticket-item">
                    <div class="ticket-header">
                      <span class="ticket-title">{{ payment.transaction_reference }}</span>
                      <span :class="{
                        'badge bg-warning text-dark p-1': payment.posted == '0',
                        'badge bg-success p-1': payment.posted == '1'
                      }" class="ticket-status">
                        {{ payment.posted == '1' ? 'Closed' : 'Open' }}
                      </span>
                    </div>

                    <p class="ticket-response">
                      <strong>Amount:</strong>
                      <span>{{ payment.amount_paid }}</span>
                    </p>

                    <p class="ticket-date">
                      <strong>Created:</strong>
                      {{ new Date(payment.paid_at).toLocaleDateString('en-GB') }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <!-- Store Credit -->
          <section class="card">
            <div class="card-b">
                <span class="credit">Credit balance: $ {{ userDetails?.balance || 0.00 }}</span>
            </div>
          </section>
        </div>

        <!-- Tickets Section -->
        <div v-else-if="currentSection === 'tickets'" class="grid">
          <section class="card full">
            <header class="card-h flex justify-between items-center">
              <span>TICKETS</span>
              <button class="btn btn-new-ticket"  @click="$emit('open-support')">
                + New Ticket
              </button>
            </header>
            <div class="card-b">
              <p v-if="tickets.length === 0">No Ticket Submitted.</p>

              <div v-else>
                <table class="ticket-table desktop-only">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Subject</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Created</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(ticket, index) in tickets" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ ticket.subject }}</td>
                      <td>{{ ticket.description }}</td>
                      <td>
                        <span :class="{
                          'badge bg-warning text-dark p-1': ticket.ticket_status === 'open',
                          'badge bg-secondary p-1': ticket.ticket_status === 'pending',
                          'badge bg-success p-1': ticket.ticket_status === 'closed'
                        }">
                          {{ ticket.ticket_status }}
                        </span>
                      </td>
                      <td>{{ new Date(ticket.created_at).toLocaleDateString('en-GB') }}</td>
                      <td>
                        <button v-if="ticket.ticket_status === 'open'" class="btn btn-xs btn-danger"
                          aria-label="Close Ticket" @click="closeTicket(ticket)">
                          Close
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <ul class="ticket-list mobile-only">
                  <li v-for="(ticket, index) in tickets" :key="index" class="ticket-item">
                    <div class="ticket-header">
                      <span class="ticket-title">{{ ticket.subject }}</span>
                      <span :class="{
                        'badge bg-warning text-dark p-1': ticket.ticket_status === 'open',
                        'badge bg-secondary p-1': ticket.ticket_status === 'pending',
                        'badge bg-success p-1': ticket.ticket_status === 'closed'
                      }" class="ticket-status">
                        {{ ticket.ticket_status }}
                      </span>
                    </div>

                    <p class="ticket-response">
                      <strong>Description:</strong>
                      <span>{{ ticket.description }}</span>
                    </p>

                    <p class="ticket-date">
                      <strong>Created:</strong>
                      {{ new Date(ticket.created_at).toLocaleDateString('en-GB') }}
                    </p>

                    <button v-if="ticket.ticket_status === 'open'" class="btn btn-xs btn-danger"
                      aria-label="Close Ticket" @click="closeTicket(ticket)">
                      Close
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>

        <!-- Referrals Section -->
        <div v-else-if="currentSection === 'referrals'" class="grid">
          <section class="card full">
            <header class="card-h flex justify-between items-center">
              <span>MY REFERRALS</span>
            </header>
            <div class="card-b">
              <p v-if="tickets.length === 0">No Referral Submitted.</p>

              <div v-else>
                <table class="ticket-table desktop-only">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Subject</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Created</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(ticket, index) in tickets" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ ticket.subject }}</td>
                      <td>{{ ticket.description }}</td>
                      <td>
                        <span :class="{
                          'badge bg-warning text-dark p-1': ticket.ticket_status === 'open',
                          'badge bg-secondary p-1': ticket.ticket_status === 'pending',
                          'badge bg-success p-1': ticket.ticket_status === 'closed'
                        }">
                          {{ ticket.ticket_status }}
                        </span>
                      </td>
                      <td>{{ new Date(ticket.created_at).toLocaleDateString('en-GB') }}</td>
                      <td>
                        <button v-if="ticket.ticket_status === 'open'" class="btn btn-xs btn-danger"
                          aria-label="Close Ticket" @click="closeTicket(ticket)">
                          Close
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <ul class="ticket-list mobile-only">
                  <li v-for="(ticket, index) in tickets" :key="index" class="ticket-item">
                    <div class="ticket-header">
                      <span class="ticket-title">{{ ticket.subject }}</span>
                      <span :class="{
                        'badge bg-warning text-dark p-1': ticket.ticket_status === 'open',
                        'badge bg-secondary p-1': ticket.ticket_status === 'pending',
                        'badge bg-success p-1': ticket.ticket_status === 'closed'
                      }" class="ticket-status">
                        {{ ticket.ticket_status }}
                      </span>
                    </div>

                    <p class="ticket-response">
                      <strong>Description:</strong>
                      <span>{{ ticket.description }}</span>
                    </p>

                    <p class="ticket-date">
                      <strong>Created:</strong>
                      {{ new Date(ticket.created_at).toLocaleDateString('en-GB') }}
                    </p>

                    <button v-if="ticket.ticket_status === 'open'" class="btn btn-xs btn-danger"
                      aria-label="Close Ticket" @click="closeTicket(ticket)">
                      Close
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>

        <!-- Messages Section -->
        <div v-else-if="currentSection === 'messages'" class="grid">
          <section class="card full">
            <header class="card-h flex justify-between items-center">
              <span>MESSAGES</span>
              <button class="btn btn-new-ticket" @click="openEdit('ticket')">
                + New Message
              </button>
            </header>
            <div class="card-b">
              <p v-if="tickets.length === 0">No Messages.</p>

              <div v-else>
                <table class="ticket-table desktop-only">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Subject</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Created</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(ticket, index) in tickets" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ ticket.subject }}</td>
                      <td>{{ ticket.description }}</td>
                      <td>
                        <span :class="{
                          'badge bg-warning text-dark p-1': ticket.ticket_status === 'open',
                          'badge bg-secondary p-1': ticket.ticket_status === 'pending',
                          'badge bg-success p-1': ticket.ticket_status === 'closed'
                        }">
                          {{ ticket.ticket_status }}
                        </span>
                      </td>
                      <td>{{ new Date(ticket.created_at).toLocaleDateString('en-GB') }}</td>
                      <td>
                        <button v-if="ticket.ticket_status === 'open'" class="btn btn-xs btn-danger"
                          aria-label="Close Ticket" @click="closeTicket(ticket)">
                          Close
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <ul class="ticket-list mobile-only">
                  <li v-for="(ticket, index) in tickets" :key="index" class="ticket-item">
                    <div class="ticket-header">
                      <span class="ticket-title">{{ ticket.subject }}</span>
                      <span :class="{
                        'badge bg-warning text-dark p-1': ticket.ticket_status === 'open',
                        'badge bg-secondary p-1': ticket.ticket_status === 'pending',
                        'badge bg-success p-1': ticket.ticket_status === 'closed'
                      }" class="ticket-status">
                        {{ ticket.ticket_status }}
                      </span>
                    </div>

                    <p class="ticket-response">
                      <strong>Description:</strong>
                      <span>{{ ticket.description }}</span>
                    </p>

                    <p class="ticket-date">
                      <strong>Created:</strong>
                      {{ new Date(ticket.created_at).toLocaleDateString('en-GB') }}
                    </p>

                    <button v-if="ticket.ticket_status === 'open'" class="btn btn-xs btn-danger"
                      aria-label="Close Ticket" @click="closeTicket(ticket)">
                      Close
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>

        <!-- Notifications Section -->
        <div v-else-if="currentSection === 'notifications'" class="grid">
          <section class="card full">
            <header class="card-h flex justify-between items-center">
              <span>NOTIFICATIONS</span>
            </header>
            <div class="card-b">
              <p v-if="tickets.length === 0">No Notifications.</p>

              <div v-else>
                <table class="ticket-table desktop-only">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Subject</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Created</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(ticket, index) in tickets" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ ticket.subject }}</td>
                      <td>{{ ticket.description }}</td>
                      <td>
                        <span :class="{
                          'badge bg-warning text-dark p-1': ticket.ticket_status === 'open',
                          'badge bg-secondary p-1': ticket.ticket_status === 'pending',
                          'badge bg-success p-1': ticket.ticket_status === 'closed'
                        }">
                          {{ ticket.ticket_status }}
                        </span>
                      </td>
                      <td>{{ new Date(ticket.created_at).toLocaleDateString('en-GB') }}</td>
                      <td>
                        <button v-if="ticket.ticket_status === 'open'" class="btn btn-xs btn-danger"
                          aria-label="Close Ticket" @click="closeTicket(ticket)">
                          Close
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <ul class="ticket-list mobile-only">
                  <li v-for="(ticket, index) in tickets" :key="index" class="ticket-item">
                    <div class="ticket-header">
                      <span class="ticket-title">{{ ticket.subject }}</span>
                      <span :class="{
                        'badge bg-warning text-dark p-1': ticket.ticket_status === 'open',
                        'badge bg-secondary p-1': ticket.ticket_status === 'pending',
                        'badge bg-success p-1': ticket.ticket_status === 'closed'
                      }" class="ticket-status">
                        {{ ticket.ticket_status }}
                      </span>
                    </div>

                    <p class="ticket-response">
                      <strong>Description:</strong>
                      <span>{{ ticket.description }}</span>
                    </p>

                    <p class="ticket-date">
                      <strong>Created:</strong>
                      {{ new Date(ticket.created_at).toLocaleDateString('en-GB') }}
                    </p>

                    <button v-if="ticket.ticket_status === 'open'" class="btn btn-xs btn-danger"
                      aria-label="Close Ticket" @click="closeTicket(ticket)">
                      Close
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>

    <!-- Update Modal -->
    <UpdateData
      :show="showModal"
      :currentForm="editForm"
      :productForm="prodForm"
      :userDetails="userDetails"
      @close="showModal = false"
      @toast="showToast"
      @updated="refreshUser"
      @logout="logout"
    />
  </div>
</template>

<script setup>
import {
  ref,
  onMounted,
  watch,
  getCurrentInstance,
} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import UpdateData from '@/components/Modals/UpdateData.vue'
import Config from '@/components/Helpers/Config.js'

const API_BASE_URL = Config.API_BASE_URL
const route = useRoute()
const router = useRouter()

const { appContext } = getCurrentInstance()
const $toast = appContext.config.globalProperties.$toast

const isLoggedIn = ref(false)
const userDetails = ref({})
const currentSection = ref('account')

const showModal = ref(false)
const editForm = ref(null)
const error = ref('')
const tickets = ref([])
const orders = ref([])
const payments = ref([])
const atickets = ref([])

const paymentSearch = ref('')
const currentPage = ref(1)

function openEdit(form) {
  editForm.value = form
  showModal.value = true
}

function navigateTo(section) {
  currentSection.value = section
  router.push({ path: '/account', query: { tab: section } })
}

function refreshUser() {
  const token = localStorage.getItem('auth_token')
  if (token) {
    isLoggedIn.value = true
    getUserDetails()
  }
}

async function getUserDetails() {
  try {
    const storedUser = localStorage.getItem('user_data');
    const userData = JSON.parse(storedUser);
    const token = localStorage.getItem('auth_token')
    const response = await fetch(`${API_BASE_URL}/details`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `PRIMEPAY ${token}`,
        'user': userData.id
      },
      body: JSON.stringify({ email: JSON.parse(localStorage.getItem('user_data')).email })
    })

    if (response.status === 401) {
      logout()
      return
    }
    const result = await response.json()
    if (!response.ok || result.success === '0') throw new Error(result.errorDesc || 'Failed to fetch user details')
    userDetails.value = result.errorDesc
  } catch (err) {
    console.error('Error fetching user details:', err)
    error.value = err.message
  }
}

async function getTickets() {
  try {
    const token = localStorage.getItem('auth_token')
    const user = JSON.parse(localStorage.getItem('user_data'))
    if (!user?.id) return
    const response = await fetch(`${API_BASE_URL}/gettickets`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `PRIMEPAY ${token}`,
        'user': user.id
      },
      body: JSON.stringify({ customer_id: user.id })
    })

    if (response.status === 401) {
      logout()
      return
    }
    const result = await response.json()
    tickets.value = response.ok && result.success !== '0' ? result.tickets || [] : []
  } catch (err) {
    console.error('Error fetching tickets:', err)
    tickets.value = []
  }
}

async function getOpenTickets() {
  try {
    const token = localStorage.getItem('auth_token')
    const user = JSON.parse(localStorage.getItem('user_data'))
    if (!user?.id) return
    const response = await fetch(`${API_BASE_URL}/getopentickets`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `PRIMEPAY ${token}`,
        'user': user.id
      },
      body: JSON.stringify({})
    })

    if (response.status === 401) {
      logout()
      return
    }
    const result = await response.json()
    atickets.value = response.ok && result.success !== '0' ? result.tickets || [] : []
  } catch (err) {
    console.error('Error fetching tickets:', err)
    atickets.value = []
  }
}

async function getOrders() {
  try {
    const token = localStorage.getItem('auth_token')
    const user = JSON.parse(localStorage.getItem('user_data'))
    if (!user?.id) return
    const response = await fetch(`${API_BASE_URL}/getorders`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `PRIMEPAY ${token}`,
        'user': user.id
      },
      body: JSON.stringify({ customer_id: user.id })
    })

    if (response.status === 401) {
      logout()
      return
    }
    const result = await response.json()
    orders.value = response.ok && result.success !== '0' ? result.orders || [] : []
  } catch (err) {
    console.error('Error fetching orders:', err)
    orders.value = []
  }
}

async function getPayments() {
  try {
    const token = localStorage.getItem('auth_token')
    const user = JSON.parse(localStorage.getItem('user_data'))
    if (!user?.id) return
    const response = await fetch(`${API_BASE_URL}/getpayments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `PRIMEPAY ${token}`,
        'user': user.id
      },
      body: JSON.stringify({ customer_id: user.id })
    })

    if (response.status === 401) {
      logout()
      return
    }
    const result = await response.json()
    payments.value = response.ok && result.success !== '0' ? result.payments || [] : []
  } catch (err) {
    console.error('Error fetching payments:', err)
    payments.value = []
  }
}

watch(paymentSearch, () => {
  currentPage.value = 1
})

watch(currentSection, (val) => {
  if (val === 'tickets') getTickets()
  if (val === 'orders') getOrders()
  if (val === 'payments') getPayments()
})

onMounted(() => {
  const tab = route.query.tab
  if (tab && ['account', 'orders', 'payments', 'tickets', 'products', 'users', 'admintickets', 'adminpayments'].includes(tab)) {
    currentSection.value = tab
  }
  const token = localStorage.getItem('auth_token')
  if (token) {
    isLoggedIn.value = true
    refreshUser()
  }
})

watch(
  () => route.query.tab,
  (newTab) => {
    if (newTab && ['account', 'orders', 'payments', 'tickets', 'products', 'users', 'admintickets', 'adminpayments'].includes(newTab)) {
      currentSection.value = newTab
    }
  }
)

async function closeTicket(ticket) {
  try {
    const token = localStorage.getItem('auth_token')
    const user = JSON.parse(localStorage.getItem('user_data'))

    const response = await fetch(`${API_BASE_URL}/close_ticket`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `PRIMEPAY ${token}`,
        'user': user.id
      },
      body: JSON.stringify({ ticket_id: ticket.ticket_id })
    })

    if (response.status === 401) {
      logout()
      return
    }
    const result = await response.json()
    if (!response.ok || result.success === '0') {
      notify('An error has occurred', 'error')
      return
    }
    notify('Ticket closed successfully', 'success')
    getTickets()
    getOpenTickets()
  } catch (err) {
    console.error('Error closing ticket:', err)
    notify('An error has occurred', 'error')
  }
}

// function showToast(payload) {
//   console.log('Toast:', payload)
// }

function notify(message, type = 'default') {
  $toast.open({ message, type, position: 'top-right', duration: 3000 })
}

function logout() {
  localStorage.removeItem('auth_token')
  localStorage.removeItem('user_data')
  isLoggedIn.value = false
  userDetails.value = {}
  window.location.href = '/'
}

</script>

<style scoped>
.account-page {
  background: #f5f6f7;
  padding: 24px 0;
}

.account-shell {
  width: 1200px;
  max-width: 95%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 20px;
}

/* Sidebar */
.account-sidebar {
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  padding: 10px 0;
  height: fit-content;
}

.account-sidebar .nav {
  list-style: none;
  margin: 0;
  padding: 0;
  display: block;
}

.account-sidebar .nav li {
  display: block;
  width: 100%;
  margin: 0;
}

.account-sidebar .nav li+li {
  margin-top: 10px;
}

.account-sidebar .nav li a {
  display: block;
  width: 100%;
  padding: 12px 16px;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  transition: background 0.2s ease;
}

.account-sidebar .nav li a:hover {
  background: #f3f3f3;
}

.account-sidebar .nav li a.active {
  color: #334155;
  font-weight: 600;
  background: #eaeff7;
}

/* Content */
.account-content .page-title {
  font-size: 24px;
  margin-bottom: 16px;
  color: #333;
  font-weight: 600;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}

.card {
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  overflow: hidden;
}

.card.full {
  grid-column: span 2;
}

.card-h {
  padding: 14px 16px;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333;
}

.card-b {
  padding: 16px;
  font-size: 14px;
}

.muted {
  color: #666;
}

.icon-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  line-height: 0;
}

.icon-btn i {
  font-size: 14px;
  color: #1e293b;
}

.credit {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #1a4da1;
  font-weight: 600;
}

.btn-new-ticket {
  background-color: var(--primary-color);
  color: white;
  font-size: 0.85rem;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-new-ticket:hover {
  background-color: var(--primary-color);
  opacity: 0.6;
}

/*Responsive */
@media (max-width: 960px) {
  .account-shell {
    grid-template-columns: 1fr;
  }

  /* Sidebar: turn into horizontal nav bar */
  .account-sidebar {
    border: none;
    border-radius: 0;
    padding: 0;
    background: #fff;
  }

  .account-sidebar .nav {
    display: flex;
    justify-content: space-around;
    align-items: center;
    overflow-x: auto;
    white-space: nowrap;
    background: #fff;
    border-bottom: 1px solid #ddd;
    scrollbar-width: none;
    /* hide scrollbar in Firefox */
  }

  .account-sidebar .nav::-webkit-scrollbar {
    display: none;
    /* hide scrollbar in Chrome/Safari */
  }

  .account-sidebar .nav li {
    flex: 1 0 auto;
    text-align: center;
    margin: 0;
  }

  .account-sidebar .nav li a {
    display: inline-block;
    padding: 10px 14px;
    font-size: 13px;
    color: #333;
    text-decoration: none;
    text-align: center;
    border-bottom: 3px solid transparent;
    transition: all 0.2s ease;
  }

  .account-sidebar .nav li a.active {
    color: #334155;
    font-weight: 600;
    border-bottom: 3px solid #334155;
    background: none;
  }

  .account-sidebar .nav li a:hover {
    background: #f3f3f3;
  }

  /* Grid stacks */
  .grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .card-h {
    font-size: 13px;
    padding: 10px 12px;
  }

  .card-b {
    font-size: 13px;
    padding: 12px;
  }

  .account-content .page-title {
    font-size: 18px;
    text-align: center;
    margin-bottom: 12px;
  }

  .btn-new-ticket {
    padding: 6px 10px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .account-page {
    padding: 10px 0;
  }

  .account-sidebar .nav li a {
    padding: 8px 10px;
    font-size: 12px;
  }

  .card-b {
    font-size: 12px;
  }

  .credit span {
    font-size: 13px;
  }
}

/* ticket */
/* Table styling (desktop) */
.ticket-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.ticket-table th,
.ticket-table td {
  padding: 10px;
  border-bottom: 1px solid #eee;
  text-align: left;
}

.ticket-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
}

/* Ticket Status Colors */
.ticket-status {
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 13px;
}

.status-open {
  background: rgba(0, 123, 255, 0.1);
  color: #007bff;
}

.status-pending {
  background: rgba(255, 152, 0, 0.1);
  color: #ff9800;
}

.status-closed {
  background: rgba(76, 175, 80, 0.1);
  color: #4caf50;
}

/* Mobile card layout */
.ticket-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.ticket-item {
  background: #f9fafc;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.ticket-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.ticket-title {
  font-weight: 600;
  color: #333;
}

.ticket-response,
.ticket-date {
  font-size: 14px;
  margin: 3px 0;
}

/* Responsive visibility */
.desktop-only {
  display: table;
}

.mobile-only {
  display: none;
}

/* On small screens, hide table and show cards */
@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: block;
  }
}

.btn-xs {
  padding: 0.3rem;
  font-size: 0.7rem;
  line-height: 1;
  border-radius: 0.15rem;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.search-input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.9rem;
  width: 200px;
  transition: all 0.2s ease;
}

.actions {
  position: relative;
  text-align: center;
}

.icon-btn.menu-btn {
  border: none;
  background: none;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 4px;
  color: #555;
  transition: 0.2s ease;
}

.actions {
  position: relative;
  text-align: center;
}

.icon-btn.menu-btn {
  border: none;
  background: none;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 4px;
  color: #555;
  transition: color 0.2s ease;
}

.dropdown-menu {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 9999 !important;
  display: flex;
  flex-direction: column;
  min-width: 120px;
  padding: 4px 0;
}

.dropdown-item {
  background: none;
  border: none;
  padding: 8px 12px;
  width: 100%;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.dropdown-item:hover {
  background-color: #f2f2f2;
}

.dropdown-item.delete {
  color: red;
}

.admin-line {
  display: flex;
  align-items: center;
  text-align: center;
  width: 90%;
  margin: auto;
  font-size: 0.6rem;
}

.admin-line::before,
.admin-line::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #000; /* continuous line */
}

.admin-line::before {
  margin-right: 8px; /* spacing between line and text */
}

.admin-line::after {
  margin-left: 8px;
}

.logouticon {
  background: #fff;
  color: #dc3545 !important;
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
}
</style>
